var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSettingsIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23,
    height: 24,
    viewBox: "0 0 23 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-ios-settings",
    "data-name": "Icon ionic-ios-settings",
    d: "M25.6,16.5a3.086,3.086,0,0,1,1.9-2.88,12.534,12.534,0,0,0-1.42-3.568,2.862,2.862,0,0,1-3.294-.631,3.189,3.189,0,0,1-.611-3.437A11.436,11.436,0,0,0,18.761,4.5a2.915,2.915,0,0,1-5.522,0,11.47,11.47,0,0,0-3.42,1.481,3.18,3.18,0,0,1-.611,3.437,2.891,2.891,0,0,1-2.09.9,2.8,2.8,0,0,1-1.2-.269A12.814,12.814,0,0,0,4.5,13.623a3.136,3.136,0,0,1,.006,5.761,12.535,12.535,0,0,0,1.42,3.568,2.874,2.874,0,0,1,3.288.637,3.19,3.19,0,0,1,.611,3.43,11.537,11.537,0,0,0,3.42,1.481,2.91,2.91,0,0,1,5.51,0,11.47,11.47,0,0,0,3.42-1.481,3.192,3.192,0,0,1,.611-3.43,2.874,2.874,0,0,1,3.288-.637,12.607,12.607,0,0,0,1.42-3.568A3.1,3.1,0,0,1,25.6,16.5Zm-9.547,4.992a4.9,4.9,0,0,1-4.792-5,4.9,4.9,0,0,1,4.792-5,4.9,4.9,0,0,1,4.792,5A4.9,4.9,0,0,1,16.054,21.489Z",
    transform: "translate(-4.5 -4.5)",
    fill: "#293462"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingsIcon);
export default __webpack_public_path__ + "static/media/SettingsIcon.b2b97e48ae5b6a286e6cd0a03511aea6.svg";
export { ForwardRef as ReactComponent };